import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 20px 1fr 20px;
	gap: 20px;
	align-items: center;
	padding: 0 20px 20px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledDotsButton = styled.img`
	width: 20px;
	height: 20px;
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 0.3s ease;
	user-select: none;

	&:hover {
		opacity: 1;
	}
`;

const StyledDropdownWrapper = styled.div`
	position: absolute;
	top: 30px;
	right: 20px;
	z-index: 10;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

const StyledMessagesContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 375px;
	overflow-y: scroll;
	padding: 20px 20px 0;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledNewMessagesContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 30px;
	min-height: 30px;
	background-color: rgba(255, 62, 62, 0.1);
	border-radius: 10px;

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ff3e3e;
	}
`;

const StyledSendContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 40px;
	gap: 10px;
	margin-top: 20px;
	padding: 0 20px;
`;

const StyledInput = styled.input`
	width: 100%;
	height: 40px;
	padding: 12px 15px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	background-color: transparent;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;

	&:focus {
		outline: none;
	}

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
		user-select: none;
	}

	&:hover {
		&::placeholder {
			color: rgba(255, 255, 255, 0.5);
		}
	}
`;

const StyledButton = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 40px;
	height: 40px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	transition: background-color 0.3s ease;
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: ${(props) => (props.$active ? 1 : 0.25)};
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	${(props) =>
		props.$active &&
		css`
			cursor: pointer;

			&:hover {
				background-color: #ffffff;

				img {
					filter: invert(1);
				}
			}
		`}
`;

export {
	StyledButton,
	StyledDotsButton,
	StyledDropdownWrapper,
	StyledHead,
	StyledInput,
	StyledMessagesContainer,
	StyledNewMessagesContainer,
	StyledSendContainer,
};
